
import LocationSelector from '@/components/LocationSelector.vue'
import DebounceInput from '@/components/DebounceInput.vue'
import BasicTableComponent from '@/components/Table/BasicTableComponent.vue'
// This exports the plugin object.
export default {
  // The install method will be called with the Vue constructor as         
  // the first argument, along with possible options
  install (Vue, options) {
    Vue.component('LocationSelector', LocationSelector)
    Vue.component('BasicTableComponent', BasicTableComponent)
    Vue.component('DebounceInput', DebounceInput)
  }
}